import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import SensitiveFieldShield from 'garaje/components/sensitive-field-shield';
import type SensitiveFieldsVisibilityService from 'garaje/services/sensitive-fields-visibility';

interface SensitiveColumnHeaderSignature {
  Args: {
    name: string;
  };
  Element: HTMLSpanElement;
}

export default class SensitiveColumnHeader extends Component<SensitiveColumnHeaderSignature> {
  @service declare sensitiveFieldsVisibility: SensitiveFieldsVisibilityService;

  get isRevealed(): boolean {
    return this.sensitiveFieldsVisibility.isRevealed(this.args.name);
  }

  toggleRevealed = (): void => {
    this.sensitiveFieldsVisibility.toggle(this.args.name);
  };

  <template>
    <span class="inline-flex items-center" ...attributes>
      <SensitiveFieldShield />
      <button
        type="button"
        class="inline-flex items-center ml-4 text-carbon-50"
        aria-label={{if this.isRevealed "Hide column values" "Reveal column values"}}
        aria-pressed={{if this.isRevealed "true" "false"}}
        data-test-sensitive-column-toggle
        {{on "click" this.toggleRevealed}}
      >
        {{svgJar
          (if this.isRevealed "sensitive-eye-slashed" "open-eye-grayLight")
          width="16"
          height="16"
          class="[&_path]:fill-current [&_circle]:fill-current"
        }}
      </button>
    </span>
  </template>
}
